import SecondaryLayout from 'components/global/SecondaryLayout';
import { $user } from 'signals/global.signals';
import { Navigate } from 'react-router-dom';

const OnboardingLayout = ({ children }) => {
  if ($user.value.onboardingStep === 'completed') {
    return <Navigate to={$user.value.userType === 'investor' ? '/investor/dashboard' : '/founder/dashboard'} replace />;
  }
  return (
    <SecondaryLayout>
      {children}
    </SecondaryLayout>
  );
};

export default OnboardingLayout;
